module.exports = require("sign-addon");


//////////////////
// WEBPACK FOOTER
// external "sign-addon"
// module id = 196
// module chunks = 0